module.exports = __webpack_public_path__ + "static/media/r3.22bff4b1.jpg";